import type { i18n as I18n } from "i18next";

import { htmlLangOf } from "./languages";

/**
 * Keeps the page's <html lang> at the editor's language (screen readers, the browser's own translation and
 * hyphenation go by it): the one it has now, and each one it changes to. Returns how to stop.
 */
export const keepDocumentLanguage = (i18n: I18n) => {
  const write = (language: string) => {
    document.documentElement.lang = htmlLangOf(language);
  };
  write(i18n.language);
  i18n.on("languageChanged", write);
  return () => i18n.off("languageChanged", write);
};
